<template>
    <div :data-overlay="navOverlayBanner">
        <component
            :is="bannerComponent"
        />
    </div>
</template>

<script setup>
    const { digistormSettings, appId, globalSets, getGlobalSetField } = storeToRefs(useGlobalStore())
    const { entry } = storeToRefs(useEntryStore())

    const { isMicrosite } = storeToRefs(useMicrositeStore())

    const settings = computed(() => {
        const navigationSet = find(globalSets.value, { __typename: 'ds_Navigation_GlobalSet'})

        return {
            ...Object.entries(navigationSet).reduce((acc, [key]) => {
                acc[key] = getGlobalSetField.value('ds_Navigation_GlobalSet', key)
                return acc
            }, {})
        }
    })

    const navOverlayBanner = computed(() => {
        if (isMicrosite.value) {
            return !settings.value.mainNav_ShowBackground
        }
        return !get(entry.value, 'hideBanner', true) && !settings.value.mainNav_ShowBackground
    })

    const bannerType = computed(() => {
        return digistormSettings.value.pageBannerType || 'internal-page-banner-default'
    })

    // check for any custom headers
    const customComponents = await import(`~/custom/${appId.value}/index.js`)
        .catch(() => {
            return null
        })

    const bannerComponent = computed(() => {
        if (bannerType.value === 'internal-page-banner-custom') {
            return customComponents?.default?.InternalBanner
        }

        return defineAsyncComponent(() => {
            // this can be removed after v0.3 release
            const type = bannerType.value === 'banner-default' ? 'internal-page-banner-default' : bannerType.value
            return import(`./page/${type}/banner.async.vue`)
        })
    })

</script>
